import { defineEntity, custom } from './_helpers.js';

export default defineEntity('operationalRun', {
    started: custom({ scope: 'state' }),
    paused: custom({ scope: 'state' }),
    resumed: custom({ scope: 'state' }),
    completed: custom({ scope: 'state' }),
    cancelled: custom({ scope: 'state' }),
    'task.assigned': custom({ scope: 'state' }),
    'task.started': custom({ scope: 'state' }),
    'task.completed': custom({ scope: 'state' }),
    'task.cancelled': custom({ scope: 'state' }),
    'task.evidenceUploaded': custom({ scope: 'state' }),
    'task.dependenciesOverridden': custom({ scope: 'state' }),
    'task.reassigned': custom({ scope: 'state' }),
    'task.deadlineWarning': custom({ scope: 'state' }),
    'task.overdue': custom({ scope: 'state' }),
    'update.appended': custom({ scope: 'state' }),
});
